<template>
    <div>
        <v-dialog
            v-model="show"
            width="600"
            content-class="confirm-action-modal overflow-x-hidden"
            @click:outside="closeModal"
        >
            <v-card class="confirm-action-modal__card">
                <div class="d-flex mb-11 align-center flex-wrap">
					<div class="confirm-action-modal__title text-center">
						{{ title }}
					</div>
				</div>
                <div class="button_group">
                    <v-btn 
                        class="confirm-action-modal__button action-cancel elevation-0"
                        @click="closeModal"
                        outlined
                    >
                        Cancel
                    </v-btn>
                    <v-btn 
                        class="confirm-action-modal__button action-submit elevation-0"
                        @click="confirmAction"
                        :loading="isLoading"
                    >
                        {{ actionName }}
                    </v-btn>
                </div>
                <v-btn 
					icon 
                    :disabled="isLoading"
					class="confirm-action-modal__button-close"
                    style="background-color: #fff !important;"
					@click="closeModal"
				>
					<v-icon color="#0055A3">mdi-close</v-icon>
				</v-btn>
            </v-card>
        </v-dialog>
        </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        actionName: {
            type: String,
            default: ''
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closeModal() {
            if (!this.isLoading) {
                this.$emit('closeModal')
            }
        },
        confirmAction() {
            if (!this.isLoading) {
                this.$emit('confirmAction')
            }
        }
    }
}
</script>

<style lang="scss">
.button_group {
	margin-left: 120px;
	@media (max-width: 480px) {
		margin-left: 0;
	}
}
.confirm-action-modal {
	border-radius: 10px;

	&__card {
		padding: 30px;
	}
    &__title {
		color: var(--accent-color);
		font-size: 24px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}
    &__button-close {
		position: absolute;
		top: 5px;
		right: 5px;
		width: 25px!important;
	}
    &__button {
		width: 138px;
        flex-grow: 1;
        border-width: 2px;
        border-radius: 8px;
        font-size: 16px !important;
        font-weight: 700;
        text-transform: capitalize;

        &:disabled {
            border: none;
        }
    }
    .action {
        &-cancel {
            background: #fff !important;
            color: var(--accent-color) !important;
            margin-right: 8px;
        }
        &-submit {
            background: var(--accent-color) !important;
            color: #fff !important;
            margin-left: 8px;
        }
    }
}
</style>